/* Utilities for Amazon promotional events (config-driven dates) */
import { parse, isValid, endOfDay, isWithinInterval } from 'date-fns';
function parseLocalYMD(dateStr) {
    if (typeof dateStr !== 'string') {
        return null;
    }
    const d = parse(dateStr, 'yyyy-MM-dd', new Date());
    return isValid(d) ? d : null;
}

function isWithinDateRange(now, startStr, endStr) {
    const start = parseLocalYMD(startStr);
    const end = parseLocalYMD(endStr);
    if (!start || !end) {
        return false;
    }
    return isWithinInterval(now, { start, end: endOfDay(end) });
}

/**
 * Determine if Big Deal Days are active for a given country based on dates from config.
 * - countryCode: 'us' | 'ca'
 * - datesConfig: { us: { start: 'YYYY-MM-DD', end: 'YYYY-MM-DD' }, ca: { start, end } }
 * - now: Date instance (optional)
 */
export function isPrimeBigDealDaysActiveForCountry(countryCode, datesConfig, now = new Date()) {
    const cc = (countryCode || 'us').toLowerCase();
    const dates = datesConfig || {};

    if (cc === 'us') {
        return isWithinDateRange(now, dates.us?.start, dates.us?.end);
    }
    if (cc === 'ca') {
        return isWithinDateRange(now, dates.ca?.start, dates.ca?.end);
    }
    return false;
}

/**
 * Determine whether Amazon Prime Big Deal Days should be active for a given user.
 * - config: object at config.amazonPrimeBigDealDays
 *   - isActive: boolean manual override
 *   - autoEnable: boolean (default true)
 *   - dates: { us: { start, end }, ca: { start, end } }
 * - countryCode: 'us' | 'ca' (others will not auto-activate)
 * - now: Date instance (optional)
 */
export function isAmazonPrimeBigDealDaysActiveEffective(config, countryCode, now = new Date()) {
    const autoEnable = config?.autoEnable !== false; // default true
    if (!autoEnable) {
        return false;
    }
    return isPrimeBigDealDaysActiveForCountry(countryCode, config?.dates, now);
}
